import { Room } from '@/core/api/room.api'
import _ from 'lodash'

export default {
  getUsersCount: state => {
    return state.users.length
  },
  me: (state, getters, rootState, rootGetters) => {
    return rootState.room.me;
  },
  getRoomUser: (state, getters, rootState, rootGetters) => userId => {
    if(typeof(userId) === 'object') {
      userId = userId.userId
    }

    let roomUser = rootState.room.roomUserObj[userId];
    return roomUser;
  },
  isMe: (state, getters, rootState, rootGetters) => (userId) => {
    if(typeof(userId) === 'object'){
      userId = userId.userId;
    }
    let me = getters.me;
    return me && me.userId === userId;
  },
  isGuest: (state, getters, rootState, rootGetters) => (roomUser) => {
    if(roomUser === undefined){
      roomUser = getters.me;
    }else if(typeof(roomUser) === 'string'){
      roomUser = getters.getRoomUser(roomUser);
    }
    
    return roomUser && roomUser.userType === 'guest';
  },
  isOpener: (state, getters, rootState, rootGetters) => userId => {
    if(typeof(userId) === 'object') {
      userId = userId.userId
    }
    if(!userId){
      userId = getters.me?.userId;
    }

    let openerId = rootState.room.room.userId;
    return userId === openerId;
  },
  isGuestUser: (state, getters, rootState, rootGetters) => userId => {
    if(!userId){
      userId = getters.me?.userId;
    }
    let roomUser = getters.getRoomUser(userId)
    return roomUser.userType === 'guest';
  },
  hasSpeaker: (state, getters, rootState, rootGetters) => {
    return getters.roomUserList.some(roomUser => roomUser.roomUserRole.roleId === 'speaker');
  },
  hasEmceeRole: (state, getters, rootState, rootGetters) => (roomUser) => {
    if(roomUser === undefined){
      roomUser = getters.me;
    }else{
      roomUser = getters.getRoomUser(roomUser);
    }
    if(!roomUser || !roomUser.roomUserRole){
      return false;
    }

    let role = roomUser.roomUserRole;
    let roleId = role.roleId;
    return ( getters.isOpener(roomUser) || getters.hasSpeakerRole(roomUser) || roleId === 'emcee');
  },
  hasSpeakerRole: (state, getters, rootState, rootGetters) => (roomUser) => {
    if(roomUser === undefined){
      roomUser = getters.me;
    }else{
      roomUser = getters.getRoomUser(roomUser);
    }
    if(!roomUser || !roomUser.roomUserRole){
      return false;
    }

    let role = roomUser.roomUserRole;
    let roleId = role.roleId;
    return (roleId === 'speaker');
  },
  isParticipantRole: (state, getters, rootState, rootGetters) => (roomUser) => {
    if(roomUser === undefined){
      roomUser = getters.me;
    }else{
      roomUser = getters.getRoomUser(roomUser);
    }
    if(!roomUser || !roomUser.roomUserRole){
      return false;
    }

    let role = roomUser.roomUserRole;
    let roleId = role.roleId;
    return roleId === 'participant';
  },
  isEmceeRole: (state, getters, rootState, rootGetters) => (roomUser) => {
    if(roomUser === undefined){
      roomUser = getters.me;
    }else{
      roomUser = getters.getRoomUser(roomUser);
    }
    if(!roomUser || !roomUser.roomUserRole){
      return false;
    }

    let role = roomUser.roomUserRole;
    let roleId = role.roleId;
    return roleId === 'emcee';
  },
  isObserverRole: (state, getters, rootState, rootGetters) => () => {
    let roomUser = getters.me;

    if(!roomUser || !roomUser.roomUserRole){
      return false;
    }

    let role = roomUser.roomUserRole;
    let roleId = role.roleId;
    return roleId === 'obs';
  },
  hasRoleFunction: (state, getters, rootState, rootGetters) => (roleFunction, roomUser) => {
    if(roomUser === undefined){
      roomUser = getters.me;
    }else{
      roomUser = getters.getRoomUser(roomUser);
    }
    if(!roomUser || !roomUser.roomUserRole){
      return false;
    }

    return !!roomUser.roomUserRole[roleFunction];
  },
  hasRoomGroupRole: (state, getters, rootState, rootGetters) => ({roomUser, roomGroupId}) => {
    if(!roomUser) roomUser = getters.me;
    if(roomGroupId === 'default'){
      return getters.hasEmceeRole(roomUser);
    }

    return rootGetters["room/isRoomMode"]('group')
      && roomUser.roomGroupId === roomGroupId;
  },
  roomUserListExceptMe: (state, getters, rootState, rootGetters) => {
    return rootState.room.roomUserList.filter(user => user.userId !== getters.me.userId)
  },
  roomUserList: (state, getters, rootState, rootGetters) => {
    return rootState.room.roomUserList
  },
  attendanceList: (state, getters, rootState, rootGetters) => {
    return rootState.user.attendanceList
  },
  roomUserCount: (state, getters, rootState, rootGetters) => {
    return rootState.room.roomUserList?.length || 0
  },
  roomUserListSpeaker: (state, getters) => {
    return getters.roomUserList.filter(roomUser => roomUser.roomUserRole.roleId === 'speaker');
  },
  roomUserListEmcee: (state, getters) => {
    return getters.roomUserList.filter(roomUser => roomUser.roomUserRole.roleId === 'speaker' || roomUser.roomUserRole.roleId === 'emcee');
  },
  getScreenShareUser: (state, getters) => {
      let roomUser = getters.roomUserList.find(roomUser => roomUser.screenStatus);
      if (!roomUser) {
        return null;
      }
      return roomUser;
  },
  isScreenShareUserMe: (state, getters) => {
    const screenShareUser = getters.getScreenShareUser;
    if (!screenShareUser) {
      return false;
    }
    return screenShareUser.userId === getters.me.userId;
  },
  getUserDeviceStatus: (state, getters) => (deviceType, roomUser) => {
    if(!roomUser) {
      roomUser = getters.me
    }

    roomUser = getters.getRoomUser(roomUser);

    const deviceUserRole = roomUser.roomUserRole[deviceType]
    const deviceUserStatus = roomUser[`${deviceType}Status`]

    return {
      'on': deviceUserStatus === 'on' || deviceUserRole,
      'off': deviceUserStatus === 'off',
      'none': !deviceUserRole,
      'error': deviceUserRole && deviceUserStatus === 'none'
    }
  },

  createUserColor: (state, getters) => (userId) => {
    function hashCode(str) { // java String#hashCode
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      return hash;
    }

    function intToRGB(i){
      let c = (i & 0x00FFFFFF)
          .toString(16)
          .toUpperCase();

      return '#' + ("00000".substring(0, 6 - c.length) + c);
    }

    if(typeof userId === 'object'){
      userId = userId.userId;
    }

    let roomUser = getters.getRoomUser(userId);
    if(roomUser){
      userId += roomUser.username;
    }

    return intToRGB( hashCode(userId) );
  },

  roomUserIds: (state, getters, rootState, rootGetters) => {
    return rootState.room.roomUserList.map(rul => rul.userId);
  },

  hasUserInChannel: (state, getters, rootState, rootGetters) => (userId) => {
    if (typeof(userId) === 'object') {
      userId = userId.userId;
    }

    const mixingLayoutData = rootGetters['call/getRoomCallMixingLayoutData'];
    const pageDetail = mixingLayoutData.secondStream?.pageInfo?.pageDetail
                        || mixingLayoutData.pageInfo?.pageDetail;
    if (!pageDetail) {
      return;
    }

    const hasUserInChannel = pageDetail.some(page => {
      return page.userIdSeq.includes(userId);
    });

    return hasUserInChannel;
  },

  // 유저 닉네임(이름) 가져오기
  getUsername: (state, getters, rootState, rootGetters) => (userId) => {
    const roomUser = !userId ? getters.me : getters.getRoomUser(userId);
    const username = roomUser?.nickname || roomUser?.username;

    return username?.escapeXml();
  },

  // 비디오 레이아웃 안에 유저가 있는지 확인
  hasUserInMixingVideo: (state, getters, rootState, rootGetters) => (roomUserId, targetPageIndex, channel) => {
    const mixingLayoutData = rootGetters['call/getRoomCallMixingLayoutData'];
    const pageDetail = mixingLayoutData.secondStream?.pageInfo.pageDetail || mixingLayoutData.pageInfo.pageDetail;
    if (!pageDetail) {
      return;
    }

    const hasUserInMixingVideo = pageDetail.some((page, idx) => {
      if (targetPageIndex !== idx) return false;

      if (!page.channelSeq.includes(channel)) return false;

      const targetUserIdSeqIdx = page.userIdSeq.split(',').findIndex(userId => userId === roomUserId);
      const targetChannelSeq = Number(page.channelSeq.split(',')[targetUserIdSeqIdx]);

      return channel !== targetChannelSeq;
    });

    return hasUserInMixingVideo;
  },
  roomUserListOrderByEnterDateDesc: (state, getters, rootState, rootGetters) => {
    return _.sortBy(getters['roomUserList'], 'enterDate').reverse()
  },
  userVideoQuality: (state, getters, rootState, rootGetters) => {
    return state.userVideoQuality
  },
  createMixerChannelRtspUser: (state, getters, rootState, rootGetters) => (userId)=> {
    const rtspUserId = rootGetters["call/getRoomCallMixingChannelRtspUser"](userId)
    if (!rtspUserId) {
      return null;
    }
    return {
      userId: rtspUserId,
      nickname: rtspUserId,
      cameraStatus: 'on',
      micStatus: 'on',
      roomUserRole: {
        // camera: 'on',
        // mic: 'on',
        roleId: 'rtsp'
      }
    };
  },
  getMixerChannelRtspUser: (state, getters, rootState, rootGetters) => (userId) => {
    return state.mixerRtspUserList.find(u => u.userId === userId);
  },
}
